const MRPA = {
  dataInicio: '',
  criacoes: [],
  tiposManejo: [],
  tiposTratamento: [],
  outrosTiposTratamento: '',
  tiposAproveitamentoResiduos: [],
  outrosTiposAproveitamentoResiduos: '',
  financiamentos: [],
  outroFinanciamento: '',
  descricao: ''
}

export default MRPA



// WEBPACK FOOTER //
// ./src/libs/models/cadastro/praticas/MRPA.js